"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapApiToPanoramaPoints = void 0;
const tech_1 = require("../../../tech");
const Config_1 = require("../../../tech/Config");
const mapApiToPanoramaPoints = (data, lau) => {
    const url = `${(0, Config_1.getConfigValue)("PANORAMA_FILES_BASE_PATH")}/${lau}/${data.nazev}`;
    const location = [
        (0, tech_1.apiToFloatNumber)(data.latitude_deg) || 0,
        (0, tech_1.apiToFloatNumber)(data.longitude_deg) || 0
    ];
    const movedLocation = addPanoramaOffset(location);
    return {
        url: url,
        location: movedLocation,
        direction: (0, tech_1.apiToFloatNumber)(data.heading_deg) || 0,
        datum: (0, tech_1.apiToDate)(data.datum_porizeni)
    };
};
exports.mapApiToPanoramaPoints = mapApiToPanoramaPoints;
const addPanoramaOffset = (location) => {
    return [location[0] + 0.00003, location[1] + 0.00006];
};
